import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface ToolUsageData {
    tool: string;
    count: number;
}

interface ToolUsageChartProps {
    data: ToolUsageData[];
}

const ToolUsageChart: React.FC<ToolUsageChartProps> = ({ data }) => {

    const formatTooltipValue = (value: number | undefined) => {
        return [`${value ?? 0} calls`, 'Tool Calls'];
    };

    const chartData = data.map(item => ({
        ...item,
        tool: item.tool.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()),
    }));

    return (
        <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--muted-foreground))" opacity={0.1} />
                    <XAxis
                        dataKey="tool"
                        stroke="hsl(var(--muted-foreground))"
                        fontSize={12}
                        angle={-45}
                        textAnchor="end"
                        height={60}
                    />
                    <YAxis
                        stroke="hsl(var(--muted-foreground))"
                        fontSize={12}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: "hsl(var(--background))",
                            borderColor: "hsl(var(--border))",
                            borderRadius: '8px',
                        }}
                        labelStyle={{ color: "hsl(var(--muted-foreground))" }}
                        formatter={formatTooltipValue}
                    />
                    <Bar
                        dataKey="count"
                        fill="hsl(var(--primary))"
                        radius={[4, 4, 0, 0]}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ToolUsageChart;
